import { Card, CardBody, Col } from "reactstrap";
import { H6, Image, LI, P, UL } from "../../../../../AbstractElements";
import { RecentPostsTitle } from "../../../../../Constants/Constants";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { RecentPostsData } from "../../../../../Data/Miscellaneous/Blog";
import { dynamicImage } from "../../../../../Utils";

const RecentPosts = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={RecentPostsTitle} headClass="pb-0 border-0" />
        <CardBody>
          <UL className="recent-blog simple-list ">
            {RecentPostsData.map((item, index) => (
              <LI key={index}>
                <div className="d-flex gap-2 align-items-start">
                  <Image className="img-fluid rounded" src={dynamicImage(item.image)} alt="Generic placeholder image" />
                  <div className="flex-grow-1">
                    <H6>{item.title}</H6>
                    <P>{item.timeAgo}</P>
                  </div>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentPosts;
